import { render, staticRenderFns } from "./MoveNews.vue?vue&type=template&id=4fd7f389&scoped=true&"
import script from "./MoveNews.vue?vue&type=script&lang=js&"
export * from "./MoveNews.vue?vue&type=script&lang=js&"
import style0 from "./MoveNews.vue?vue&type=style&index=0&id=4fd7f389&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7f389",
  null
  
)

export default component.exports